<div class="user-area-page">
  <mat-tab-group
    class="user-area-page__tabs"
    #tabGroup
    (selectedTabChange)="changeTab($event)"
    animationDuration="0ms"
    disableRipple
  >
    @if (hasMoreClients()) {
      <mat-tab [aria-label]="userArea.CUSTOMER">
        <ng-template mat-tab-label>
          <div class="user-area-page__tab-label">
            <span>{{ 'CLIENTI' | translate }}</span>
          </div>
        </ng-template>

        <div class="user-area-page__section">
          @if (filterAreaForm) {
            <div class="user-area-page__filter-shell">
              <form
                [autocomplete]="'off'"
                [formGroup]="filterAreaForm"
                class="user-area-filter-card"
              >
                <div class="user-area-filter-card__header">
                  <div class="user-area-filter-card__title-block">
                    <span class="user-area-filter-card__eyebrow font-walter">
                      {{ 'pages.catalogList.filters' | translate }}
                    </span>
                    <!--                    <span class="user-area-filter-card__eyebrow font-walter">-->
                    <!--                      User Area-->
                    <!--                    </span>-->
                    <!--                    <h3 class="user-area-filter-card__title">-->
                    <!--                      Clienti-->
                    <!--                    </h3>-->
                  </div>
                </div>

                <div class="user-area-filter-card__content">
                  <div class="user-area-filter-card__grid user-area-filter-card__grid--filters">
                    @if (canShowFilter(UserAreaFilter.USERID)) {
                      <app-input
                        type="text"
                        formControlName="code"
                        [label]="'CODICE' | translate"
                        (keyup.enter)="search()"
                      ></app-input>
                    }

                    <app-input
                      type="text"
                      formControlName="name"
                      [label]="'NOME_E_COGNOME' | translate"
                      (keyup.enter)="search()"
                    ></app-input>

                    <app-input
                      type="text"
                      formControlName="email"
                      [label]="'EMAIL' | translate"
                      (keyup.enter)="search()"
                    ></app-input>

                    @if (canShowFilter(UserAreaFilter.INTERCOMPANY)) {
                      <app-input
                        type="selection"
                        [selectionOptions]="intercompanies"
                        formControlName="intercompanyId"
                        [label]="'INTERCOMPANY' | translate"
                        [showNullOption]="true"
                      ></app-input>
                    }

                    @if (canShowFilter(UserAreaFilter.AGENCY)) {
                      <app-input
                        type="selection"
                        [selectionOptions]="agencies"
                        formControlName="agencyId"
                        [label]="'AGENZIA' | translate"
                        [showNullOption]="true"
                      ></app-input>
                    }

                    @if (canShowFilter(UserAreaFilter.SHOWROOM)) {
                      <app-input
                        type="selection"
                        [selectionOptions]="showrooms"
                        formControlName="showroomId"
                        [label]="'SHOWROOM' | translate"
                        [showNullOption]="true"
                      ></app-input>
                    }

                    @if (canShowFilter(UserAreaFilter.CUSTOMERCHANNEL)) {
                      <app-input
                        type="selection"
                        [selectionOptions]="channels"
                        formControlName="customerChannelId"
                        [label]="'CUSTOMER_CHANNEL' | translate"
                        [showNullOption]="true"
                      ></app-input>
                    }

                    @if (canShowFilter(UserAreaFilter.SHOPVENDOR)) {
                      <app-input
                        type="selection"
                        [selectionOptions]="shopVendors"
                        formControlName="shopVendorId"
                        [label]="'SHOP_VENDOR' | translate"
                        [showNullOption]="true"
                      ></app-input>
                    }

                    <app-input
                      type="selection"
                      [selectionOptions]="countries"
                      formControlName="countryId"
                      [label]="'NAZIONE' | translate"
                      [showNullOption]="true"
                    ></app-input>
                  </div>
                </div>

                <div class="user-area-filter-card__footer">
                  <button
                    type="button"
                    class="user-area-filter-card__btn user-area-filter-card__btn--primary force-text-white"
                    (click)="search()"
                  >
                    <i class="icon-ipe-lens" aria-hidden="true"></i>
                    <span>{{ 'generics.cols.search' | translate }}</span>
                  </button>

                  <button
                    type="button"
                    class="user-area-filter-card__btn user-area-filter-card__btn--secondary"
                    (click)="reset()"
                  >
                    <i class="icon-ipe-clear" aria-hidden="true"></i>
                    <span>{{ 'generics.cols.clean' | translate }}</span>
                  </button>

                  <div class="user-area-filter-card__spacer"></div>

                  <button
                    type="button"
                    class="user-area-filter-card__btn user-area-filter-card__btn--primary force-text-white"
                    (click)="registerNewUser()"
                  >
                    <span>{{ 'CREA' | translate }}</span>
                  </button>
                </div>
              </form>
            </div>
          }

          @if (currentFilters(); as filters) {
            @if (filters.length > 0) {
              <div class="user-area-page__summary">
                <span class="user-area-page__summary-label">{{ 'FILTRA_PER' | translate }}:</span>
                <div class="user-area-page__summary-list">
                  @for (filter of filters; track filter) {
                    <span class="user-area-page__summary-chip">
                      <i>{{ filter.keyT | translate }}</i>: <b>{{ filter.value }}</b>
                    </span>
                  }
                </div>
              </div>
            }
          }

          <div class="user-area-page__content-shell">
            <app-clients
              [search]="search$"
              (selected)="selectedCustomerEvent($event)"
              class="d-block"
            ></app-clients>
          </div>
        </div>
      </mat-tab>
    }

    <mat-tab [aria-label]="userArea.ORDER">
      <ng-template mat-tab-label>
        <div class="user-area-page__tab-label">
          <span>{{ 'PROFORMA' | translate }}</span>
        </div>
      </ng-template>

      <div class="user-area-page__section">
        @if (filterAreaForm && selectedTab === userArea.ORDER) {
          <div class="user-area-page__filter-shell">
            <form
              [autocomplete]="'off'"
              [formGroup]="filterAreaForm"
              class="user-area-filter-card"
            >
              <div class="user-area-filter-card__header">
                <div class="user-area-filter-card__title-block">
                  <span class="user-area-filter-card__eyebrow font-walter">
                      {{ 'pages.catalogList.filters' | translate }}
                    </span>
                  <!--                  <span class="user-area-filter-card__eyebrow font-walter">-->
                  <!--                    User Area-->
                  <!--                  </span>-->
                  <!--                  <h3 class="user-area-filter-card__title">-->
                  <!--                    Proforma-->
                  <!--                  </h3>-->
                </div>
              </div>

              <div class="user-area-filter-card__content">
                <div class="user-area-filter-card__grid user-area-filter-card__grid--filters">
                  <app-input
                    type="text"
                    formControlName="name"
                    [label]="'NUMERO_NOME' | translate"
                    (keyup.enter)="search()"
                  ></app-input>

                  <app-input
                    type="text"
                    formControlName="customerName"
                    [label]="'CLIENTE' | translate"
                    (keyup.enter)="search()"
                  ></app-input>

                  @if (canShowFilter(UserAreaFilter.INTERCOMPANY)) {
                    <app-input
                      type="selection"
                      [selectionOptions]="intercompanies"
                      formControlName="intercompanyId"
                      [label]="'INTERCOMPANY' | translate"
                      [showNullOption]="true"
                    ></app-input>
                  }

                  @if (canShowFilter(UserAreaFilter.AGENCY)) {
                    <app-input
                      type="selection"
                      [selectionOptions]="agencies"
                      formControlName="agencyId"
                      [label]="'AGENZIA' | translate"
                      [showNullOption]="true"
                    ></app-input>
                  }

                  @if (canShowFilter(UserAreaFilter.SHOWROOM)) {
                    <app-input
                      type="selection"
                      [selectionOptions]="showrooms"
                      formControlName="showroomId"
                      [label]="'SHOWROOM' | translate"
                      [showNullOption]="true"
                    ></app-input>
                  }

                  @if (categories.length > 1) {
                    <app-input
                      type="selection"
                      [selectionOptions]="categories"
                      formControlName="categoryId"
                      [label]="'CATEGORIA' | translate"
                      [showNullOption]="true"
                    ></app-input>
                  }

                  <app-input
                    type="selection"
                    [selectionOptions]="states"
                    formControlName="status"
                    [label]="'STATO' | translate"
                    [showNullOption]="true"
                  ></app-input>

                  <app-input
                    [label]="'generics.cols.from' | translate"
                    formControlName="creationDateFilterStart"
                    type="date"
                    (keyup.enter)="search()"
                  ></app-input>

                  <app-input
                    [label]="'generics.cols.to' | translate"
                    formControlName="creationDateFilterEnd"
                    type="date"
                    (keyup.enter)="search()"
                  ></app-input>

                  <app-input
                    type="selection"
                    [selectionOptions]="countries"
                    formControlName="countryId"
                    [label]="'NAZIONE' | translate"
                    [showNullOption]="true"
                  ></app-input>
                </div>
              </div>

              <div class="user-area-filter-card__footer">
                <button
                  type="button"
                  class="user-area-filter-card__btn user-area-filter-card__btn--primary force-text-white"
                  (click)="search()"
                >
                  <i class="icon-ipe-lens" aria-hidden="true"></i>
                  <span>{{ 'generics.cols.search' | translate }}</span>
                </button>

                <button
                  type="button"
                  class="user-area-filter-card__btn user-area-filter-card__btn--secondary"
                  (click)="reset()"
                >
                  <i class="icon-ipe-clear" aria-hidden="true"></i>
                  <span>{{ 'generics.cols.clean' | translate }}</span>
                </button>

                <div class="user-area-filter-card__spacer"></div>

                <button
                  type="button"
                  class="user-area-filter-card__btn user-area-filter-card__btn--primary force-text-white"
                  (click)="openCreateOrderModal()"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  <span>{{ 'CREA' | translate }}</span>
                </button>
              </div>
            </form>
          </div>
        }

        @if (currentFilters(); as filters) {
          @if (filters.length > 0) {
            <div class="user-area-page__summary">
              <span class="user-area-page__summary-label">{{ 'FILTRA_PER' | translate }}:</span>
              <div class="user-area-page__summary-list">
                @for (filter of filters; track filter) {
                  <span class="user-area-page__summary-chip">
                    <i>{{ filter.keyT | translate }}</i>: <b>{{ filter.value }}</b>
                  </span>
                }
              </div>
            </div>
          }
        }

        <div class="user-area-page__content-shell">
          <app-proforma
            [search]="search$"
            (selected)="selectedOrderEvent($event)"
            class="d-block"
          ></app-proforma>
        </div>
      </div>
    </mat-tab>

    <mat-tab [aria-label]="userArea.ETO">
      <ng-template mat-tab-label>
        <div class="user-area-page__tab-label">
          <span>{{ 'ETO' | translate }}</span>
        </div>
      </ng-template>

      <div class="user-area-page__section">
        @if (filterAreaForm && selectedTab === userArea.ETO) {
          <div class="user-area-page__filter-shell">
            <form
              [autocomplete]="'off'"
              [formGroup]="filterAreaForm"
              class="user-area-filter-card"
            >
              <div class="user-area-filter-card__header">
                <div class="user-area-filter-card__title-block">
                  <span class="user-area-filter-card__eyebrow font-walter">
                      {{'pages.catalogList.filters' | translate }}
                    </span>
<!--                  <span class="user-area-filter-card__eyebrow font-walter">-->
<!--                    User Area-->
<!--                  </span>-->
<!--                  <h3 class="user-area-filter-card__title">-->
<!--                    ETO-->
<!--                  </h3>-->
                </div>
              </div>

              <div class="user-area-filter-card__content">
                <div class="user-area-filter-card__grid user-area-filter-card__grid--filters">
                  <app-input
                    type="text"
                    formControlName="code"
                    [label]="'CODICE' | translate"
                    (keyup.enter)="search()"
                  ></app-input>

                  <app-input
                    type="text"
                    formControlName="customerName"
                    [label]="'CLIENTE' | translate"
                    (keyup.enter)="search()"
                  ></app-input>

                  <app-input
                    type="selection"
                    [selectionOptions]="etoStates"
                    formControlName="etoStatus"
                    [label]="'STATO' | translate"
                    [showNullOption]="true"
                  ></app-input>
                </div>
              </div>

              <div class="user-area-filter-card__footer">
                <button
                  type="button"
                  class="user-area-filter-card__btn user-area-filter-card__btn--primary force-text-white"
                  (click)="search()"
                >
                  <i class="icon-ipe-lens" aria-hidden="true"></i>
                  <span>{{ 'generics.cols.search' | translate }}</span>
                </button>

                <button
                  type="button"
                  class="user-area-filter-card__btn user-area-filter-card__btn--secondary"
                  (click)="reset()"
                >
                  <i class="icon-ipe-clear" aria-hidden="true"></i>
                  <span>{{ 'generics.cols.clean' | translate }}</span>
                </button>
              </div>
            </form>
          </div>
        }

        @if (currentFilters(); as filters) {
          @if (filters.length > 0) {
            <div class="user-area-page__summary">
              <span class="user-area-page__summary-label">{{ 'FILTRA_PER' | translate }}:</span>
              <div class="user-area-page__summary-list">
                @for (filter of filters; track filter) {
                  <span class="user-area-page__summary-chip">
                    <i>{{ filter.keyT | translate }}</i>: <b>{{ filter.value }}</b>
                  </span>
                }
              </div>
            </div>
          }
        }

        <div class="user-area-page__content-shell">
          <app-eto
            [search]="search$"
            (selected)="selectedOrderEvent($event)"
            class="d-block"
          ></app-eto>
        </div>
      </div>
    </mat-tab>

    <mat-tab [aria-label]="userArea.CATALOG">
      <ng-template mat-tab-label>
        <div class="user-area-page__tab-label">
          <span>{{ 'pages.catalogList.header' | translate }}</span>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #proformaFormModal>
  <div [formGroup]="proformaForm" class="user-area-order-modal">
    <div class="user-area-order-modal__header">
      <span class="user-area-order-modal__eyebrow font-walter">
        {{ 'pages.user.area.user.area.proforma' | translate }}
      </span>
      <h2 class="user-area-order-modal__title">
        {{ 'CREA_NUOVO_ORDINE' | translate }}
      </h2>
      <p class="user-area-order-modal__description">
        {{ 'SELEZIONA_UTENTE_ORDINE' | translate }}
      </p>
    </div>

    <div class="user-area-order-modal__body">
      <mat-form-field appearance="outline" class="user-area-order-modal__field">
        <mat-select formControlName="customerId">
          @for (customer of lists.customer; track customer) {
            <mat-option [value]="customer.id">
              {{ customer?.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="user-area-order-modal__footer">
      <button
        type="button"
        class="user-area-order-modal__btn user-area-order-modal__btn--secondary"
        (click)="closeModal()"
      >
        {{ 'ANNULLA' | translate }}
      </button>

      <button
        type="button"
        class="user-area-order-modal__btn user-area-order-modal__btn--primary"
        (click)="createOrder()"
        [disabled]="proformaForm.invalid"
      >
        {{ 'CONFERMA' | translate }}
      </button>
    </div>
  </div>
</ng-template>
